export default __webpack_public_path__ + "static/media/github.16a9304e.svg";